'use strict';

exports.__esModule = true;
exports.searchFacetSuggest = exports.searchAll = exports.searchAutocompleteMarketplace = exports.searchAutocomplete = exports.searchAdvisors = exports.searchProviders = exports.searchMarketplace = undefined;

var _fetch = require('./fetch');

var _appsmartIdentity = require('../constants/appsmart-identity');

var getSearchApiUrl = function getSearchApiUrl() {
    return (0, _fetch.getMarketplaceBaseUrl)() + '/api/appwise/v2/core/users/me/index/search';
};
var getAutocompleteApiUrl = function getAutocompleteApiUrl() {
    return (0, _fetch.getMarketplaceBaseUrl)() + '/api/appwise/v2/core/users/me/index/autocomplete';
};
var getMarketplaceApiUrl = function getMarketplaceApiUrl() {
    return (0, _fetch.getMarketplaceBaseUrl)() + '/api/appwise/v2/core/marketplaces/' + (0, _fetch.getMarketplaceDomain)() + '/index/search';
};
var getAutocompleteMarketplaceApiUrl = function getAutocompleteMarketplaceApiUrl() {
    return (0, _fetch.getMarketplaceBaseUrl)() + '/api/appwise/v2/core/marketplaces/' + (0, _fetch.getMarketplaceDomain)() + '/index/autocomplete';
};
var getFacetSuggestApiUrl = function getFacetSuggestApiUrl() {
    return (0, _fetch.getMarketplaceBaseUrl)() + '/api/appwise/v2/core/users/me/index/suggest';
};

function buildUrl(baseUrl, params) {
    var query = Object.keys(params).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return baseUrl.includes('?') ? baseUrl + '&' + query : baseUrl + '?' + query;
}

function sanitize(input) {
    // Some symbols should be ignored during autocomplete for a better user experience
    var sanitizingRegExp = RegExp(/[®,©]/g);
    return input.replace(sanitizingRegExp, '');
}

var convertFacets = function convertFacets() {
    var facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return facets.reduce(function (memo, facet, i) {
        if (i % 2 === 0) {
            return memo.concat({
                count: facets[i + 1],
                type: facet
            });
        }

        return memo;
    }, []);
};

var searchMarketplace = exports.searchMarketplace = function searchMarketplace(query) {
    var params = {
        page_size: 5,
        q: query
    };

    // On AppSmart, add a 'pl' query parameter containing comma-separated values of all non-provider and non-advisor
    // product lines
    if ((0, _appsmartIdentity.isAppSmart)()) {
        params.pl = ((0, _appsmartIdentity.getMarketplaceProductLines)() || []).join();
    }

    var url = buildUrl(getMarketplaceApiUrl(), params);

    return (0, _fetch.get)(url).then(function (data) {
        return data.response.docs;
    }).catch(function () {
        return [];
    });
};

var searchProviders = exports.searchProviders = function searchProviders(query) {
    // Use same URL as marketplace, but add a 'pl' query parameter specific to providers
    var url = buildUrl(getMarketplaceApiUrl(), {
        page_size: 5,
        q: query,
        pl: (0, _appsmartIdentity.getProvidersProductLine)()
    });

    return (0, _fetch.get)(url).then(function (data) {
        return data.response.docs;
    }).catch(function () {
        return [];
    });
};

var searchAdvisors = exports.searchAdvisors = function searchAdvisors(query) {
    // Use same URL as marketplace, but add a 'pl' query parameter specific to advisors
    var url = buildUrl(getMarketplaceApiUrl(), {
        page_size: 5,
        q: query,
        pl: (0, _appsmartIdentity.getAdvisorsProductLine)()
    });

    return (0, _fetch.get)(url).then(function (data) {
        return data.response.docs;
    }).catch(function () {
        return [];
    });
};

var searchAutocomplete = exports.searchAutocomplete = function searchAutocomplete(query) {
    var apiUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getAutocompleteApiUrl();
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var AUTOCOMPLETE_MAX_WORD_COUNT = 7;
    var getWordCount = function getWordCount(value) {
        return value && value.split(' ').length;
    };

    var url = buildUrl(apiUrl, Object.assign({
        q: query
    }, options));

    return (0, _fetch.get)(url).then(function (data) {
        // Autocomplete is not yet filter aware.
        // Therefore, the following logic is trying to create a good-enough response.
        var sanitizedQuery = sanitize(query.toLowerCase());
        var results = [];
        data.response.docs.forEach(function (doc) {
            // Autocomplete results have various (unknown) properties like title or name depending on the type.
            // Any string property that has the search query as a substring, and does not exceed the maximum
            // word count is considered a valid autocomplete term.
            var terms = Object.values(doc).filter(function (value) {
                return typeof value === 'string' && getWordCount(value) <= AUTOCOMPLETE_MAX_WORD_COUNT && sanitize(value.toLowerCase()).includes(sanitizedQuery);
            }).map(function (term) {
                return sanitize(term);
            });
            results.push.apply(results, terms);
        });

        return [].concat(new Set(results)); // Filter out duplicate terms
    }).catch(function () {
        return [];
    });
};

var searchAutocompleteMarketplace = exports.searchAutocompleteMarketplace = function searchAutocompleteMarketplace(query) {
    return searchAutocomplete(query, getAutocompleteMarketplaceApiUrl());
};

var searchAll = exports.searchAll = function searchAll(query) {
    var url = buildUrl(getSearchApiUrl(), {
        q: query,
        page_size: 5
    });

    return (0, _fetch.get)(url).then(function (data) {
        return data.response.docs.splice(0, 10);
    }).catch(function () {
        return [];
    });
};

var searchFacetSuggest = exports.searchFacetSuggest = function searchFacetSuggest(query) {
    var url = buildUrl(getFacetSuggestApiUrl(), {
        q: query
    });

    return (0, _fetch.get)(url).then(function (data) {
        return (
            // Deriving a facet count object from the response
            {
                sources: convertFacets(data.facet_counts.facet_fields.source),
                contentTypes: convertFacets(data.facet_counts.facet_fields.content_type)
            }
        );
    }).catch(function () {
        return {
            sources: [],
            contentTypes: []
        };
    });
};